import script from "./Dependents.vue?vue&type=script&setup=true&lang=js"
export * from "./Dependents.vue?vue&type=script&setup=true&lang=js"

import "./Dependents.vue?vue&type=style&index=0&id=05abe3a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05abe3a0"]])

export default __exports__